import { useEffect, useState } from "react";
import alqemiDataService from "../../api/AlqemiDataService";
import EditBaseCV from "../../Alqemi/Settings/EditBaseCV";
import ManageConsultantRates from "../../Alqemi/Settings/ManageConsultantRates";
import ManageConsultantsCVs from "../../Alqemi/Settings/ManageConsultantsCVs";
import { useUser } from "../../common/context/UserProvider";
import { hasSalesOrAdminAccess } from "../../utils";
import ChangePassword from "./Password/ChangePassword";
import FeatureFlagsPanel from "./FeatureFlags/FeatureFlagsPanel";
import PersonalInformationSetting from "./PersonalInformationSetting";
import SettingsPage from "./SettingsPage";

export default function UserSettingsWrapper() {
  const { user } = useUser();
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [isCheckingSupervisor, setIsCheckingSupervisor] = useState(true);

  useEffect(() => {
    const checkIfSupervisor = async () => {
      if (hasSalesOrAdminAccess(user)) {
        setIsSupervisor(false);
        setIsCheckingSupervisor(false);
        return;
      }

      try {
        const allConsultants = await alqemiDataService.getCandidates();
        const supervisedConsultants = allConsultants.filter(
          (c) => !c.archived && c.supervisor_email === user.email
        );
        setIsSupervisor(supervisedConsultants.length > 0);
      } catch (error) {
        setIsSupervisor(false);
      }
      setIsCheckingSupervisor(false);
    };

    checkIfSupervisor();
  }, [user.email, user.sales, user.admin]);

  return (
    <>
      <SettingsPage heading="Account information">
        <PersonalInformationSetting />
        <ChangePassword />
      </SettingsPage>
      <SettingsPage heading="Alqemi">
        <EditBaseCV />
        {!isCheckingSupervisor && (hasSalesOrAdminAccess(user) || isSupervisor) && (
          <ManageConsultantsCVs />
        )}
        {hasSalesOrAdminAccess(user) && <ManageConsultantRates />}
        {hasSalesOrAdminAccess(user) && <FeatureFlagsPanel />}
      </SettingsPage>
    </>
  );
}
